import React, { createContext, useContext } from 'react';

const Context = createContext();

export const useAcceptance = () => useContext(Context);

export const AcceptanceProvider = ({ children, acceptance }) => {
  return <Context.Provider value={acceptance}>{children}</Context.Provider>;
};
